<div class="form-check" *ngFor="let item of items">
	<input
		type="checkbox"
		class="form-check-input"
		id="checkbox_{{ item.id }}"
		name="checkbox_{{ item.id }}"
		[checked]="internalValues[item.id]"
		[(ngModel)]="internalValues[item.id]"
		(change)="changed()"
	/>
	<label class="form-check-label" for="checkbox_{{ item.id }}">{{ item.name }}</label>
</div>
